import type { FC } from 'react';
import { Helmet } from 'react-helmet';
import { canonicalUrlCleanup } from '../../utils/canonical-url-cleanup';
import { type PrefetchUrlConfig, getPrefetchUrls } from '../../utils/performance-utils';

const urlsToPrefetch: PrefetchUrlConfig[] = [
    { hostname: 'assets.surlatable.com', addCrossOrigin: false },
];

const SearchHead: FC<{
    canonicalUrl: string;
    prevUrl?: string;
    nextUrl?: string;
}> = ({ canonicalUrl, prevUrl, nextUrl }) => (
    <Helmet>
        <link
            rel="canonical"
            href={canonicalUrlCleanup(canonicalUrl)}
            data-testid="search-canonical-link"
        />
        {prevUrl ? (
            <link rel="prev" href={canonicalUrlCleanup(prevUrl)} data-testid="search-prev-link" />
        ) : null}
        {nextUrl ? (
            <link rel="next" href={canonicalUrlCleanup(nextUrl)} data-testid="search-next-link" />
        ) : null}
        {/* @ts-expect-error: __PRODUCTION__ variable will be replaced by webpack */}
        {__PRODUCTION__ ? getPrefetchUrls(urlsToPrefetch) : null}
    </Helmet>
);

SearchHead.defaultProps = {
    prevUrl: undefined,
    nextUrl: undefined,
};

export { SearchHead };
